import { branch, compose, lifecycle, renderNothing, withHandlers, withProps, withState } from 'recompose';

import { fetchCustomerMembershipSubscription } from './actions';
import { canUserViewRegister } from '../../../../common/helpers/users';
import withPermissions from '../../../../auth/utils/withPermissions';
import withActiveType from '../../../../auth/utils/withActiveType';

const CustomerMembershipContainer = compose(
  withPermissions,
  withActiveType,
  withState('busy', 'setBusy', true),
  withState('subscription', 'setSubscription', null),
  withHandlers({
    fetchSubscription: props => async () => {
      const subscription = await fetchCustomerMembershipSubscription(props.type, props.activeId, props.customerId);
      props.setBusy(false);
      props.setSubscription(subscription);
    },
  }),
  lifecycle({
    async componentDidMount() {
      this.props.fetchSubscription();
    },
  }),
  withProps(props => ({
    canSellMembership: props.type === 'shop' && canUserViewRegister(props.permissions),
    canSeeInvoices: props.subscription && (props.type === 'brand' || props.subscription.ownerId === props.activeId),
  })),
  branch(
    props => props.busy,
    renderNothing,
  ),
);

export default CustomerMembershipContainer;
